import { render } from "./Diagram.vue?vue&type=template&id=15ec5ffc&scoped=true"
import script from "./Diagram.vue?vue&type=script&lang=js"
export * from "./Diagram.vue?vue&type=script&lang=js"

import "./Diagram.vue?vue&type=style&index=0&id=15ec5ffc&lang=css"
import "./Diagram.vue?vue&type=style&index=1&id=15ec5ffc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ec5ffc"]])

export default __exports__